import * as yup from 'yup'

const schema = yup.object().shape({
  reasonExclusion: yup.string().required().max(5000),
})

export default schema
